import styled from "styled-components";

export const CardContainer = styled.div`
	background-color: white;
	border-radius: 10px;
	.group-hover:fill-white {
		color: white;
	}
	.customButton{
		display: flex !important;
		gap: 10px
	}
	.card {
		display: block;
	}
	.card-title {
		display: flex;
		padding: 0 10px 20px 0;
		h2 {
			font-size: 1.125rem;
			font-weight: 700;
			flex: 1;
		}
	}
	.card-add {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 0 10px 10px 0;
	}
	.card-add h2 {
		color: rgba(9, 113, 162, 1);
		padding-left: 5px;
		padding-top: 5px;
		font-weight: 700;
	}
	.description {
		color: rgb(99 115 129);
	}
	.btn-add-new {
		min-width: 9.375rem;
		max-width: 9.575rem;
		// padding-left: 10px;
	}

	@media only screen and (min-width: 1025px) {
		.card-title {
			display: flex;
			padding: 0 10px 20px 0;
			h2 {
				font-size: 1.1875rem;
				font-weight: 700;
				flex: 1;
			}
		}
	}

	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		.card-title {
			display: flex;
			padding: 0 10px 20px 0;
			h2 {
				font-size: 1.1875rem;
				font-weight: 700;
				flex: 1;
			}
		}
	}

	@media only screen and (min-width: 641px) and (max-width: 767px) {
		.card-title {
			display: flex;
			padding: 0 10px 10px 0;
			h2 {
				font-size: 1.1875rem;
				font-weight: 700;
				flex: 1;
			}
		}
	}

	@media only screen and (max-width: 640px) {
		.card-title {
			display: flex;
			padding: 0 10px 10px 0;
			h2 {
				font-size: 1.1875rem;
				font-weight: 700;
				flex: 1;
			}
		}
	}
`;

export const TagOptionService = styled.span`
	background: #e8e8e8;
	border-radius: 15px;
	font-size: 0.875rem;
	padding: 5px 15px;
	font-weight: bold;
	color: rgb(99, 115, 129);
`;
